/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Tryagain1Inputs */

const zh_auth_tryagain1 = /** @type {(inputs: Auth_Tryagain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const en_auth_tryagain1 = /** @type {(inputs: Auth_Tryagain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const es_auth_tryagain1 = /** @type {(inputs: Auth_Tryagain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar de nuevo`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Auth_Tryagain1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_tryagain1 = /** @type {((inputs?: Auth_Tryagain1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Tryagain1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_tryagain1(inputs)
	if (locale === "en") return en_auth_tryagain1(inputs)
	return es_auth_tryagain1(inputs)
});
export { auth_tryagain1 as "auth_tryAgain" }